import React from 'react';
import styled from 'styled-components';
import useBookingMarkupData from '../../../hooks/useBookingMarkupData';
import {
    AvailableTimeSlots,
    BookerContainer,
    CalendarDays,
    DateCell,
    DateGrid,
    DatePickerContainer,
    DatePickerHeader,
    EventHeading,
    EventSubheading,
    MainSectionContainer,
    MetaSection,
    TimeSlotButton,
    TimeslotsContainer,
} from './BookerMarkupComponents';

const BookingMarkup = () => {
    const { date, mockInfo } = useBookingMarkupData();
    return (
        <div
            className='calcom-atoms atoms-wrapper booker-markup'
            dir='ltr'
            data-auto='cal-booking-markup'
        >
            <BookerContainer>
                <MetaSection>
                    <EventHeading>{mockInfo.userName}</EventHeading>
                    <EventSubheading>{mockInfo.eventName}</EventSubheading>
                    {mockInfo.data.map((item, index) => (
                        <Info key={index}>
                            <span>{item.icon}</span> {item.value}
                        </Info>
                    ))}
                </MetaSection>
                <MainSectionContainer>
                    <DatePickerContainer>
                        <DatePickerHeader month={date.month} year={date.year} />
                        <CalendarDays />
                        <DateGrid>
                            {[...Array(31)].map((_, i) => {
                                const day = i + 1;
                                const currentDay = date.day;
                                const isCurrentDay = day === currentDay;
                                const isInvalidDay = day < currentDay;
                                return (
                                    <DateCell
                                        key={`day_${day}`}
                                        isPreviousDay={isInvalidDay}
                                        isCurrentDay={isCurrentDay}
                                    >
                                        {day}
                                    </DateCell>
                                );
                            })}
                        </DateGrid>
                    </DatePickerContainer>
                </MainSectionContainer>
                <TimeslotsContainer>
                    <AvailableTimeSlots
                        dayInWeek={date.dayInWeek}
                        day={date.day}
                        slots={<Slots />}
                    />
                </TimeslotsContainer>
            </BookerContainer>
        </div>
    );
};

function Slots() {
    return (
        <SlotsList>
            {[
                '9:00am',
                '9:30am',
                '11:00am',
                '11:30am',
                '1:00pm',
                '1:30pm',
                '2:00pm',
                '2:30pm',
            ].map((time) => (
                <TimeSlotButton key={time}>{time}</TimeSlotButton>
            ))}
        </SlotsList>
    );
}

const SlotsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow-y: hidden;
    align-items: center;
`;

const Info = styled.div`
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export default BookingMarkup;
